import { render, staticRenderFns } from "./PriceSummaryCheckbox.vue?vue&type=template&id=6a5c73b0&"
import script from "./PriceSummaryCheckbox.vue?vue&type=script&lang=js&"
export * from "./PriceSummaryCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports